module.exports = __webpack_public_path__ + "static/media/reopen.96e4d5c5.svg";